// extracted by mini-css-extract-plugin
module.exports = {"container":"CartItemList_container__CUaDa","emptyList":"CartItemList_emptyList__fmux9"};